import React, { useEffect, createElement, Component } from 'react';
import { useLocation } from 'react-router-dom';
const GTM_ID = 'GTM-5BP8QP7K';
const VARIANT_ID = '50280035188956';
const CART_BASE = `https://shop.dermaclinicenter.com/cart/${VARIANT_ID}:1`;
declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
  }
}
function injectGTM(): void {
  if (typeof window === 'undefined') return;
  if (document.getElementById('gtm-script')) return;
  // dataLayer MUST exist before the GTM snippet executes
  window.dataLayer = window.dataLayer || [];
  // GTM main snippet — verbatim from spec, inserted high in <head>
  const script = document.createElement('script');
  script.id = 'gtm-script';
  script.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');`;
  document.head.insertBefore(script, document.head.firstChild);
  // GTM noscript fallback — verbatim from spec, inserted at top of <body>
  if (!document.getElementById('gtm-noscript')) {
    const noscript = document.createElement('noscript');
    noscript.id = 'gtm-noscript';
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);
  }
}
function captureAttribution(): void {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(window.location.search);
  const attribution = {
    utm_source: params.get('utm_source') || 'direct',
    utm_medium: params.get('utm_medium') || 'none',
    utm_campaign: params.get('utm_campaign') || 'none',
    utm_content: params.get('utm_content') || 'none',
    utm_term: params.get('utm_term') || 'none',
    fbclid: params.get('fbclid') || null,
    gclid: params.get('gclid') || null,
    ttclid: params.get('ttclid') || null
  };
  sessionStorage.setItem('armony_attribution', JSON.stringify(attribution));
  window.dataLayer?.push({
    event: 'armony_attribution_loaded',
    utm_source: attribution.utm_source,
    utm_medium: attribution.utm_medium,
    utm_campaign: attribution.utm_campaign,
    utm_content: attribution.utm_content,
    utm_term: attribution.utm_term,
    fbclid: attribution.fbclid,
    gclid: attribution.gclid
  });
}
function pushViewContent(): void {
  if (typeof window === 'undefined') return;
  window.dataLayer?.push({
    event: 'armony_view_content',
    content_name: 'ARMONY Method',
    content_category: 'digital_bundle',
    content_ids: [VARIANT_ID],
    content_type: 'product',
    value: 17.0,
    currency: 'USD'
  });
}
function buildFinalCartUrl(): string {
  try {
    const stored = sessionStorage.getItem('armony_attribution');
    if (!stored) return CART_BASE;
    const attribution = JSON.parse(stored) as Record<string, string | null | undefined>;
    const queryString = Object.keys(attribution).filter(k => {
      const v = attribution[k];
      return v && v !== 'direct' && v !== 'none';
    }).map(k => k + '=' + encodeURIComponent(String(attribution[k]))).join('&');
    return queryString ? CART_BASE + '?' + queryString : CART_BASE;
  } catch {
    return CART_BASE;
  }
}
function attachListenersAndRewriteHrefs(): void {
  if (typeof window === 'undefined') return;
  const finalCartUrl = buildFinalCartUrl();
  // CART CTAs — rewrite href + push InitiateCheckout on click
  document.querySelectorAll('[data-cta="hero"], [data-cta="final"], [data-cta="sticky"], [data-cta="legal"]').forEach(btn => {
    const el = btn as HTMLElement & {
      _gtmCart?: boolean;
    };
    // Rewrite cart href on every effect run (attribution may have updated)
    const anchor = el.tagName === 'A' ? el as unknown as HTMLAnchorElement : el.closest('a') as HTMLAnchorElement | null;
    if (anchor) anchor.href = finalCartUrl;
    if (el._gtmCart) return;
    el._gtmCart = true;
    el.addEventListener('click', () => {
      window.dataLayer?.push({
        event: 'armony_initiate_checkout',
        cta_location: el.dataset.cta,
        content_name: 'ARMONY Method',
        content_ids: [VARIANT_ID],
        content_type: 'product',
        value: 17.0,
        currency: 'USD',
        num_items: 1
      });
    });
  });
  // WHATSAPP CTAs — push Contact/Lead-equivalent event on click
  document.querySelectorAll('[data-cta="hero_whatsapp"], [data-cta="final_whatsapp"], [data-cta="footer_whatsapp"]').forEach(btn => {
    const el = btn as HTMLElement & {
      _gtmWa?: boolean;
    };
    if (el._gtmWa) return;
    el._gtmWa = true;
    el.addEventListener('click', () => {
      window.dataLayer?.push({
        event: 'armony_whatsapp_click',
        cta_location: el.dataset.cta,
        content_name: 'ARMONY Method',
        content_category: 'whatsapp_inquiry',
        value: 17.0,
        currency: 'USD'
      });
    });
  });
}
function logVerification(): void {
  if (typeof window === 'undefined') return;
  // eslint-disable-next-line no-console
  console.log('[ARMONY] GTM Container:', GTM_ID);
  // eslint-disable-next-line no-console
  console.log('[ARMONY] dataLayer initialized:', window.dataLayer);
  // eslint-disable-next-line no-console
  console.log('[ARMONY] Attribution:', sessionStorage.getItem('armony_attribution'));
  document.querySelectorAll('[data-cta]').forEach(btn => {
    const el = btn as HTMLElement;
    const anchor = (el as unknown as HTMLAnchorElement).href !== undefined && (el as unknown as HTMLAnchorElement).href ? el as unknown as HTMLAnchorElement : el.closest('a') as HTMLAnchorElement | null;
    const href = anchor?.href || null;
    // eslint-disable-next-line no-console
    console.log('[ARMONY] CTA ' + el.dataset.cta + ' →', href);
  });
}
export function GTM() {
  const location = useLocation();
  // One-time init: load GTM scripts, capture attribution from URL → sessionStorage
  useEffect(() => {
    injectGTM();
    captureAttribution();
  }, []);
  // Per-route effects: ViewContent (landing only), wire listeners, log
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (location.pathname === '/') {
      pushViewContent();
    }
    // Defer a frame so child components have rendered their DOM
    const raf = requestAnimationFrame(() => {
      attachListenersAndRewriteHrefs();
      logVerification();
    });
    return () => cancelAnimationFrame(raf);
  }, [location.pathname]);
  return null;
}